
import { Component, OnDestroy, OnInit, Renderer2, ViewChild, inject, DOCUMENT } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ComponentLoaderComponent, IdeaLoaderModule, IdeaPageLoaderService } from '@ideatech/ngx-ideatech';
import { SvgIconRegistryService } from 'angular-svg-icon';
import { Subject, takeUntil } from 'rxjs';
import { AlertsComponent } from './core/components/alerts/alerts.component';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, IdeaLoaderModule, AlertsComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {

    private readonly iconRegistryService = inject(SvgIconRegistryService);
    private readonly ideaPageLoaderService = inject(IdeaPageLoaderService);
    private readonly renderer = inject(Renderer2);
    private readonly document = inject(DOCUMENT);
    private readonly onDestroy$ = new Subject<void>();

    @ViewChild(ComponentLoaderComponent) private readonly componentLoader?: ComponentLoaderComponent;

    ngOnInit(): void {
        this.subscribeIdeaLoaderStatusChange();

        this.iconRegistryService.loadSvg('/assets/images/icons/2d.svg', '2d')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/3d.svg', '3d')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/arrow-left.svg', 'arrow-left')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/arrow-right.svg', 'arrow-right')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/arrows.svg', 'arrows')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/button.svg', 'button')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/brailletag.svg', 'brailletag')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/catalogue_new.svg', 'catalogue_new')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/circle-checkmark.svg', 'circle-checkmark')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/circle-plus.svg', 'circle-plus')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/delete.svg', 'delete')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/display.svg', 'display')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/download.svg', 'download')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/clone.svg', 'clone')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/emergency_light.svg', 'emergency_light')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/file-pdf.svg', 'file-pdf')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/grid-alt.svg', 'grid-alt')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/grid.svg', 'grid')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/home.svg', 'home')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/i-button.svg', 'i-button')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/my-projects.svg', 'my-projects')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/team-projects.svg', 'team-projects')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/key.svg', 'key')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/list-paragraph-checkmark.svg', 'list-paragraph-checkmark')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/lock.svg', 'lock')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/eye.svg', 'eye')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/lock-open.svg', 'lock-open')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/logout.svg', 'logout')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/measure-ruler-divider.svg', 'measure-ruler-divider')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/minus.svg', 'minus')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/move-arrows.svg', 'move-arrows')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/pencil.svg', 'pencil')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/pencil-ruler.svg', 'pencil-ruler')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/plus.svg', 'plus')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/project-plan-pen.svg', 'project-plan-pen')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/rotate.svg', 'rotate')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/ruler.svg', 'ruler')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/save.svg', 'save')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/send.svg', 'send')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/trash.svg', 'trash')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/user.svg', 'user')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/warning.svg', 'warning')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/zoom-minus.svg', 'zoom-minus')?.subscribe();
        this.iconRegistryService.loadSvg('/assets/images/icons/zoom-plus.svg', 'zoom-plus')?.subscribe();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    private subscribeIdeaLoaderStatusChange(): void {
        this.ideaPageLoaderService.pageLoaderStatus$.pipe(
            takeUntil(this.onDestroy$)
        ).subscribe(loaderStatus => {
            if (loaderStatus) {
                this.renderer.addClass(this.document.body, 'overflow-hidden');
                this.componentLoader?.showLoader();
            } else {
                this.renderer.removeClass(this.document.body, 'overflow-hidden');
                this.componentLoader?.hideLoader();
            }
        });
    }
}
